import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import useCommonStore from '../../../hooks/useCommonStore';

const MAX_OTP_LENGTH = 6;

const CertEmail = observer(
  ({ email, resultPath, readOnly, history, showHeader = true, hideMail = false, sendCertifyToken }) => {
    const commonStore = useCommonStore();
    const [sendEmail, setSendEmail] = useState(email);
    const [sendComplete, setSendComplete] = useState(false);
    const [otpCode, setOtpCode] = useState('');
    const [isVerifying, setIsVerifying] = useState(false);
    if (resultPath.includes(`${window.location.origin}`)) {
      resultPath = `${resultPath}`;
    } else {
      resultPath = `${window.location.origin}/${resultPath}`;
    }

    const onAuthNumSend = async () => {
      //이메일이 바뀌면 안되는 경우
      if (readOnly && email !== sendEmail) {
        return false;
      }
      const res = await commonStore.actionCertifyEmail({
        email: sendEmail,
        resultUrl: resultPath
      });

      if (res.code === 200) {
        setSendComplete(true);
      }
    };

    const onChangeEmail = (e) => {
      setSendEmail(e.target.value);
    };

    const onBack = () => {
      history.goBack();
    };

    const censorEmail = (email) => {
      const [local, domain] = email.split('@');
      if (!local || !domain) return email;

      const visibleCount = Math.ceil(local.length * 0.4);
      const censoredPart = '*'.repeat(local.length - visibleCount);

      return local.slice(0, visibleCount) + censoredPart + '@' + domain;
    };

    const onVerifyOtp = async (code) => {
      if (!code) {
        commonStore.modalStore?.openAlertModal?.({ message: '인증번호를 입력해 주세요.' });
        return;
      }
      setIsVerifying(true);
      try {
        const res = await commonStore.actionCertifyEmailCode({
          email: sendEmail,
          code
        });
        if (res?.code === 200) {
          const certifyToken = res?.data?.certify_token;
          sendCertifyToken?.(certifyToken);
        } else {
          commonStore.modalStore?.openAlertModal?.({
            message: res?.message || '인증번호가 올바르지 않습니다. 인증번호를 정확히 다시 입력해주세요.'
          });
        }
      } catch (error) {
        console.error('onVerifyOtp error', error);
      } finally {
        setIsVerifying(false);
      }
    };

    const handleVerifyOtp = () => onVerifyOtp(otpCode.trim());

    const handleChangeOtp = (e) => {
      const v = e.target.value.replace(/\D/g, '').slice(0, MAX_OTP_LENGTH);
      setOtpCode(v);
    };

    useEffect(() => {
      setSendEmail(email);
    }, [email, sendComplete]);

    return (
      <>
        {sendComplete ? (
          <div className="account_info_wrap">
            {showHeader && (
              <div className="nav">
                <h2 className="tit">이메일 인증</h2>
                <button className="btn_prev" onClick={onBack}>
                  이전으로
                </button>
              </div>
            )}
            <div className="sleeper_area">
              <div className="email_auth">
                <p>인증번호를 발송하였습니다. 받은 이메일의 인증번호를 넣어주세요.</p>
                <div className="otp_area" style={{ marginTop: '16px' }}>
                  <label className="blind" htmlFor="cert_email_otp">
                    인증번호 입력
                  </label>
                  <input
                    id="cert_email_otp"
                    type="text"
                    inputMode="numeric"
                    autoComplete="one-time-code"
                    placeholder="인증번호 6자리 입력"
                    value={otpCode}
                    onChange={handleChangeOtp}
                    maxLength={MAX_OTP_LENGTH}
                    className="input"
                    style={{ width: '100%', padding: '10px 12px', fontSize: '16px', boxSizing: 'border-box' }}
                  />
                  <div className="btn_area" style={{ marginTop: '12px' }}>
                    <button
                      type="button"
                      className="btn btn_submit"
                      onClick={handleVerifyOtp}
                      disabled={isVerifying || !otpCode.trim()}
                    >
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="account_info_wrap">
            {showHeader && (
              <div className="nav">
                <h2 className="tit">이메일 인증</h2>
                <button className="btn_prev" onClick={onBack}>
                  이전으로
                </button>
              </div>
            )}
              <div className="find_area">
              <div className="result">
                <p className="tx">아래 가입한 아이디(이메일)로 인증 메일을 발송 합니다.</p>
                <p className="email">{hideMail ? censorEmail(sendEmail) : sendEmail}</p>
              </div>
              <div className="btn_area">
                <button type="button" className="btn" onClick={onBack}>
                  취소
                </button>
                <button type="submit" className="btn btn_submit" onClick={onAuthNumSend}>
                  확인
                </button>
              </div>
            </div>
          </div>
        )}
      </>
    );
  });

export default CertEmail;
